import { render, staticRenderFns } from "./PublicProfileAbout.vue?vue&type=template&id=d5a06a90&"
import script from "./PublicProfileAbout.vue?vue&type=script&lang=js&"
export * from "./PublicProfileAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports